import ApiService from 'services/ApiService';

export default class TagsService {
  static async autocomplete(query) {
    return ApiService.get(`/tags/autocomplete?query=${query}`);
  }

  static async findAll(query) {
    const tags = await ApiService.get(`/tags?search=${query.search}`);
    return tags.data;
  }

  static async getIconTags(id) {
    return ApiService.get(`/tags/icon/${id}`);
  }
}
